/**
 * Editor test hooks — exposes LevelFormatConverter + ReachabilityAnalyzer
 * on `window` for MCP-driven editor testing tools.
 *
 * Gated on `?testhooks=1` (or `?vqa=1`) — same pattern as the render-state
 * and game-world-view hooks. Zero footprint in prod.
 *
 * Exposes:
 *   window.__h2000_LevelFormatConverter  — the converter class
 *   window.__h2000_analyzeReachability   — the reachability analyzer function
 *
 * Used by scripts/mcp/editor-test.mjs --op reachability to run static
 * level analysis against the live editor state.
 */

import { LevelFormatConverter } from '../../shared/LevelFormatConverter';
import { analyzeReachability } from '../../shared/validation/ReachabilityAnalyzer';
import { gameLogger } from '../../utils/GameLogger';
import { bootSearchParams } from '../../config/boot/bootUrl';

let _installed = false;

function isTestHooksEnabled(): boolean {
  try {
    if (typeof window === 'undefined') return false;
    const sp = bootSearchParams();
    return sp.get('testhooks') === '1' || sp.get('vqa') === '1';
  } catch {
    return false;
  }
}

export function installEditorTestHooks(): void {
  if (!isTestHooksEnabled()) return;
  if (typeof window === 'undefined') return;
  if (_installed) return;

  (window as any).__h2000_LevelFormatConverter = LevelFormatConverter;
  (window as any).__h2000_analyzeReachability = analyzeReachability;

  _installed = true;
  gameLogger.info('boot', '[EditorTestHooks] installed — LevelFormatConverter + analyzeReachability exposed via ?testhooks=1');
}
